import { SystemPage } from '@/components/system/system-page'
import { Button } from '@/components/ui/button'
import { Link } from '@tanstack/react-router'
import { Home, Search } from 'lucide-react'

export function NotFoundPage() {
  return (
    <SystemPage
      code="404"
      icon={Search}
      tone="neutral"
      title="Сторінку не знайдено"
      hint="Можливо, наряд на роботу скасовано або проєкт переміщено в архів. Перевірте посилання або поверніться до списку проєктів."
      primaryAction={
        <Button asChild>
          <Link to="/projects/">
            <Home className="size-3.5" />
            На головну
          </Link>
        </Button>
      }
    />
  )
}
